<template>
  <div class="sign-in-link">
    <button v-if="canGenerateAppLink"
            class="btn btn-primary generate-app-link"
            :title="'Generate sign-in link for KATE users'"
            @click="generateSignInLink('app')">KATE Sign-in link</button>
    <button v-if="canGenerateDashboardLink"
            class="btn btn-primary generate-dashboard-link"
            :title="'Generate sign-in link for dashboard users'"
            @click="generateSignInLink('dashboard')">Dashboard Sign-in link</button>
    <k-modal @close="close" :show="show">
      <template v-slot:header>
        <h3>Generated Sign-in Link</h3>
      </template>
      <template v-slot:body>
        <p>It is important that you <b>securely</b> share this link with only <b>{{ studentName }}</b> (ID {{ studentId }}).</p>
        <p>Either copy the link from the text area or click the "Copy to Clipboard" button below</p>
        <label for="sign-in-link-text">Sign-in link:</label>
        <textarea id="sign-in-link-text" v-model="signInLink" rows="4"></textarea>
      </template>
      <template v-slot:footer>
        <button class="btn btn-primary copy-to-clipboard" @click="copySignInLink">Copy to Clipboard</button>
        <button class="btn btn-danger close-modal" @click="close">Close</button>
      </template>
    </k-modal>
  </div>
</template>

<style scoped>
.sign-in-link p.info {
  font-size: 12px;
  font-style: italic;
  font-weight: 300;
  color: var(--kate-type-accent);
}

.sign-in-link button {
  margin-right: 10px;
}
</style>

<script>
import KModal from '@base-components/k-modal.vue';

import { copyToClipboard } from '@utils/copy-to-clipboard';

export default {
  components: { KModal },
  props: {
    studentId: {
      type: Number,
      required: true,
    },
    studentName: {
      type: String,
      required: true,
    },
    userPermissions: {
      type: Array,
      required: false,
      default: () => ([]),
    },
  },
  data() {
    return {
      signInLink: null,
    };
  },
  computed: {
    show() {
      return Boolean(this.signInLink);
    },
    canGenerateAppLink() {
      return this.$permissions.hasPermission('generate_sign_in_links');
    },
    canGenerateDashboardLink() {
      if (!this.$permissions.hasPermission('generate_dashboard_sign_in_links')) {
        return false;
      }
      return this.userPermissions && this.userPermissions.includes('access_dashboard');
    },
  },
  methods: {
    generateSignInLink(appName) {
      this.$Loading.start();
      this.$http.post(`/api/auth/user/${this.studentId}/${appName}/login-url`).then(res => {
        this.$logger.info(`Generated sign-in link for ${appName}`, { studentId: this.studentId });
        this.signInLink = res.data.url;
      }).catch(err => {
        this.$logger.error(`Error generating sign-in link for ${appName}`, undefined, err);
        this.$ktoast.showError(err);
      }).then(() => {
        this.$Loading.finish();
      });
    },
    copySignInLink() {
      copyToClipboard(this.signInLink);
      this.$ktoast.success('Sign-in link copied to clipboard');
    },
    close() {
      this.signInLink = null;
    },
  },
};
</script>
